import { useCallback } from 'react'
import type { ApiError } from '@pbt/pbt-ui-components'

import { useDeleteManualAttachmentFileMutation } from '~/api/graphql/generated/types'
import { getErrorMessage } from '~/utils/errors'

export const useDeleteManualAttachmentFile = () => {
  const [deleteManualAttachmentFileMutation, { loading, error, reset }] =
    useDeleteManualAttachmentFileMutation()

  const deleteAttachment = useCallback(
    async (fileId: string) => {
      try {
        const result = await deleteManualAttachmentFileMutation({
          variables: { id: fileId },
        })

        return result.data?.deleteManualAttachmentFile
      } catch (err) {
        throw new Error(getErrorMessage(err as ApiError))
      }
    },
    [deleteManualAttachmentFileMutation],
  )

  return {
    deleteAttachment,
    loading,
    error,
    reset,
  }
}
